var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{staticClass:"editor-slash-helper",style:(_vm.styles)},[_c('div',{staticClass:"editor-slash-helper__text"},[_vm._v("Just start typing or type \"/\" for commands")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }